export default {
    agreeTOS: '<1>プライバシーポリシー</1>および<0>利用規約</0>に同意する',
    building: 'マンション／ビル名',
    businessType: '事業形態',
    cancel: 'キャンセル',
    city: '市区町村',
    clear: '消す',
    companyEmail: '連絡先メールアドレス',
    companyName: '会社名または事業名',
    companyPhoneNumber: '会社の電話番号',
    confirm: '確定',
    country: '国名',
    create: '作成',
    delete: '削除',
    emailAddress: 'メールアドレス',
    emailAddressHelpText: '（例）tanakataro@example.com',
    employees: '従業員数',
    error: {
        emailInvalid: '有効な電子メールを入力してください',
        error: 'エラー',
        fieldIsRequired: 'この必須項目を入力してください。',
    },
    faxNumber: 'FAX番号',
    firstName: '名',
    goBack: '戻る',
    lastName: '姓',
    neighborhood: '町名・番地',
    noOptions: 'オプションはありません',
    ok: 'OK',
    password: 'パスワード',
    passwordConfirm: 'パスワードの確認',
    phoneNumber: '連絡のつきやすい電話番号',
    postcode: '郵便番号',
    postcodeAutoFill: '住所自動入力',
    prefecture: '都道府県',
    registrationCode: '招待コード',
    required: '必須',
    save: '保存',
    select: '選択',
    selectDate: '日付を選択',
    selectDateTime: '日付と時刻を選択する',
    submit: '提出',
    time: '時間を選択する',
    today: '今日',
    username: 'ユーザー名',
    workEmail: '勤務先のメールアドレス',
};
